import { render } from "./BaseIconFreetext.vue?vue&type=template&id=f4bee0e4"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconFreetext.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4bee0e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4bee0e4', __exports__)) {
    console.log('reload')
    api.reload('f4bee0e4', __exports__)
  }
  
  module.hot.accept("./BaseIconFreetext.vue?vue&type=template&id=f4bee0e4", () => {
    console.log('re-render')
    api.rerender('f4bee0e4', render)
  })

}


export default __exports__